import React from "react";
import BackgroundImage from "../Images/Black_Smiley_Face.jpg";
import ResponsiveImageGrid from "../components/Tilegrid/TileGrid";

import gifimg1 from "../Images/gifgrid/drawflip2.gif";
import gifimg2 from "../Images/gifgrid/paint.gif";
import gifimg3 from "../Images/gifgrid/paste.gif";
import gifimg4 from "../Images/gifgrid/street5.gif";
import gifimg5 from "../Images/gifgrid/walkingstreets.gif";
import gifimg6 from "../Images/gifgrid/robot.gif";




const gifgridImages = [gifimg1, gifimg2, gifimg3, gifimg5, gifimg6, gifimg4];

export default function BioGif() {
    return <div className="Section sOne" style={{ backgroundImage: `url(${BackgroundImage})` }}>
                <div className="gifgrid">
                    <ResponsiveImageGrid images={gifgridImages}/>
                </div>
                <div className="sectionText">
                    <h3>Trespassing on walls since 2015, Goldloxe’s hand-painted wheatpastes are a well-loved part of new York street art lore. Featured in books, documentaries, street art tours and with recent shows in NY and Paris - she is looking to the future. Now experimenting in digital and new mediums, the next chapter is being written. </h3>
                </div>
                
            </div>
}

